import React, { useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import { useGridCellEditor } from 'ag-grid-react';
import TimeRangeComponent from './TimeRange';

const TimeRangeEditor = forwardRef(({ onValueChange, value, ...otherProps }, ref) => {
  const dateTimeRef = useRef(value);
  const startTimeInputRef = useRef(null);
  const isEditingCompletedRef = useRef(false);
  
  const isCancelAfterEnd = useCallback(() => {
    if (isEditingCompletedRef.current) return true; // Returning true to avoid setting new value
    isEditingCompletedRef.current = true; // prevent further commits
    onValueChange(dateTimeRef.current);
    return false;
  }, [onValueChange]);

  const afterGuiAttached = useCallback(() => {
    if (startTimeInputRef?.current?.inputElement) {
      startTimeInputRef?.current?.inputElement?.focus?.();
    }
  }, []);

  useGridCellEditor({
    isCancelAfterEnd,
    afterGuiAttached
  });

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return dateTimeRef.current;
    }
  }));

  const handleUpdate = useCallback((value) => {
    dateTimeRef.current = value || null;
  }, []);

  return (
    <TimeRangeComponent
      onChange={handleUpdate}
      value={dateTimeRef.current}
      {...otherProps}
      startTimeInputRef={startTimeInputRef}
    />
  );
});

export default TimeRangeEditor;
